import React from 'react'
import { useSelector } from 'react-redux'
import { inputTypes } from '@easybutton/constants'

import { getCurrentOrganizationId } from '../../../../ducks/users'
import { getDatabases } from '../../../../ducks/databases'
import WrappedInput from '../../../Shared/Forms/WrappedInput'

const getOptions = databases => {
  let options = [
    {
      label: 'Basic Types',
      options: [
        {
          label: 'Text',
          value: inputTypes.TEXT,
        },
        {
          label: 'Password',
          value: inputTypes.PASSWORD,
        },
        {
          label: 'Number',
          value: inputTypes.NUMBER,
        },
      ],
    },
  ]

  for (let database of databases) {
    if (database.schema && database.schema.length > 0) {
      options.push({
        label: database.name,
        options: database.schema.map(table => ({
          label: table.name,
          value: [inputTypes.PRIMARY_KEY, database.id, table.name].join('.'),
        })),
      })
    }
  }

  return options
}

export default function TypeMenu({ input, meta, className }) {
  const organizationId = useSelector(getCurrentOrganizationId)
  const databases = useSelector(getDatabases(organizationId))

  if (!databases) {
    return null
  }

  const { value, onChange } = input

  const handleChange = newValue => {
    let [type, databaseId, table] = (newValue || '').split('.')

    onChange({
      ...value,
      type,
      databaseId,
      table,
    })
  }

  const options = getOptions(databases)

  const { type, databaseId, table } = value || {}

  const serializedValue =
    type === inputTypes.PRIMARY_KEY ? [type, databaseId, table].join('.') : type

  return (
    <WrappedInput
      input={{
        value: serializedValue,
        onChange: handleChange,
      }}
      label="Type"
      options={options}
      meta={meta}
      className={className}
      placeholder="Choose Type..."
    />
  )
}
